import Radio from './radio.vue'
export type { RadioProps } from './props'
export default Radio